import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useGetHotelMappingQuery} from 'modules/hotelMapping'
import {setCallToBook} from 'modules/search/slice'
import {getHotelResult} from 'modules/searchApi/selectors'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

import {useCallToBook} from './useCallToBook'

interface Props {
  hotelId?: string
}

export const InitializeCallToBook = ({hotelId = ''}: Props) => {
  const {
    commerce: {hasCallToBook}
  } = useBrandCapabilities()

  const {data: hotel} = useSelector(state => getHotelResult(state, hotelId))
  const destination = hotel?.hotelName

  const dispatch = useDispatch()
  const {data: providerHotelId} = useGetHotelMappingQuery(
    {
      hotelId,
      providerCode: 'BKS'
    },
    {
      skip: !hotelId
    }
  )
  const {status, phoneNumber, displayedPhoneNumber, href, payload} =
    useCallToBook({
      destination,
      hotelId: providerHotelId,
      skip: !providerHotelId || !hasCallToBook
    })

  useEffect(() => {
    if (payload !== null) {
      dispatch(
        setCallToBook({
          status,
          phoneNumber,
          displayedPhoneNumber,
          href,
          payload
        })
      )
    }
  }, [status, phoneNumber, displayedPhoneNumber, href, payload, dispatch])

  return null
}
